export enum MetricType {
    Like = 1,
    Share,
    Comment,
    View
}
